import type { ReactNode } from 'react';
import { cx } from '@/lib/cx';
import { Container, type ContainerWidth } from './Container';
import styles from './Section.module.css';

export type SectionBackground = 'surface' | 'alt' | 'cool' | 'aqua' | 'tone' | 'none';
export type SectionSpacing = 'default' | 'tight' | 'flush';

export interface SectionProps {
  children: ReactNode;
  /** Fondo de la banda. `none` = hereda (util si la seccion pinta su propia imagen). */
  background?: SectionBackground;
  /** Aire vertical. `flush` = cero, para bandas a sangre con imagen. */
  spacing?: SectionSpacing;
  /** Ancho del contenido. `full` no envuelve en Container. */
  width?: ContainerWidth;
  /** Necesario cuando la seccion tiene un titulo: `aria-labelledby` apunta a el. */
  labelledBy?: string;
  /** Ancla para la navegacion interna del hub. */
  id?: string;
  className?: string;
  /** Ornamentos de fondo (curvas, destellos). Van detras del contenido. */
  ornament?: ReactNode;
}

/**
 * Banda horizontal de la pagina. Controla FONDO y AIRE; nada mas.
 * El aire sale de `--az-section-y` (fluido), nunca de un padding a mano.
 */
export function Section({
  children,
  background = 'surface',
  spacing = 'default',
  width = 'default',
  labelledBy,
  id,
  className,
  ornament,
}: SectionProps) {
  return (
    <section
      id={id}
      aria-labelledby={labelledBy}
      className={cx(styles.section, styles[`bg-${background}`], styles[`sp-${spacing}`], className)}
    >
      {ornament ? (
        <div className={styles.ornament} aria-hidden="true">
          {ornament}
        </div>
      ) : null}
      {width === 'full' ? (
        <div className={styles.body}>{children}</div>
      ) : (
        <Container width={width} className={styles.body}>
          {children}
        </Container>
      )}
    </section>
  );
}
